Pegasus.HelpContext  = Em.Object.extend({
  anchorSelector: 'body',
  display: 'block',
  offset: {
    top: 0,
    left: 0
  },
  isDismissed: false,
  position: function(){
    var top,
      left,
      display,
      anchor = $(this.get('anchorSelector')),
      offset = this.get('offset');

    if ( !anchor.length ) { return; }

    top = anchor.position().top + offset.top;
    left = anchor.position().left + offset.left;
    display = this.get('display');

    $('.gps-wrapper').css({
      top: top,
      left: left,
      display: display
    });
  }
});

Pegasus.ImageHelpContext = Pegasus.HelpContext.extend({
  display: 'block',
  anchorSelector: '.root-toolbar-content-wrapper',
  offset: {
    top: 233,
    left: 282
  }
});

Pegasus.DocumentBackgroundImageHelpContext = Pegasus.HelpContext.extend({
  display: 'block',
  anchorSelector: '.root-toolbar-content-wrapper',
  offset: {
    top: 135,
    left: 282
  }
});

Pegasus.RowBackgroundImageHelpContext = Pegasus.HelpContext.extend({
  display: 'block',
  anchorSelector: '.root-toolbar-content-wrapper',
  offset: {
    top: 135,
    left: 282
  }
});

Pegasus.HelpManager = Em.Controller.extend({
  view: null,
  idling: Pegasus.HelpContext.create({
    display: 'none',
    offset: {
      top: 0,
      left: 0
    }
  }),
  initializing: Pegasus.HelpContext.create({
    display: 'none',
    offset: {
      top: 0,
      left: 0
    }
  }),
  saved: Pegasus.HelpContext.create({
    display: 'none',
    offset: {
      left: 0,
      top: 0,
    }
  })
});

Pegasus.HelpManager.reopen({
  Text: Pegasus.HelpContext.create({
    display: 'block',
    offset: {
      top: 60,
      left: 423
    }
  }),

  ViewOnline: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),

  Image: Pegasus.ImageHelpContext.create(),
  BackgroundImage: Pegasus.RowBackgroundImageHelpContext.create(),
  BodyImage: Pegasus.DocumentBackgroundImageHelpContext.create(),
  Button: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),
  Footer: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),

  Palette: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),

  CapturePalette: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),

  Divider: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top',
    offset: {
      top: 180,
      left: 180
    }
  }),
  SocialFollow: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),
  SocialShare: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  })
});

Pegasus.HelpManager.reopen({
  WebTemplateText: Pegasus.HelpContext.create({
    display: 'block',
    offset: {
      top: 60,
      left: 423
    }
  }),
  WebTemplateImage: Pegasus.ImageHelpContext.create(),
  WebTemplateBackgroundImage: Pegasus.ImageHelpContext.create(),
  WebTemplateBodyImage: Pegasus.ImageHelpContext.create(),
  WebTemplateButton: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),
  WebTemplateFooter: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .vr-toolbar',
    offset: {
      top: 2,
      left: 180
    }
  }),

  WebTemplateForm: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),

  WebTemplatePalette: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),
  WebTemplateDivider: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top',
    offset: {
      top: 180,
      left: 180
    }
  }),
  WebTemplateSocialFollow: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  }),
  WebTemplateSocialShare: Pegasus.HelpContext.create({
    display: 'block',
    anchorSelector: '.toolbar-top .sub-tabs',
    offset: {
      top: 2,
      left: 180
    }
  })
});

Pegasus.HelpManager.reopenClass({
  create: function(args){
    var instance =  Em.get( this, 'get', 'instance');
    if (instance){
      return instance;
    }

    instance = this._super(args);
    instance.set('view', Pegasus.HelpIndicatorView.create({
      controller: instance
    }));
    Em.set(this, 'instance', instance);
    return instance;
  }
});

